import React, { useEffect } from 'react';
import { usePortalPermissions, isMiManager } from '../../hooks/usePortalPermissions';
import { useUiStore } from '../../stores/uiStore';

// ============================================================
// Mail portal gate (MAIL-1). The portal is David's alone: super admin AND the
// mi_access grant (isMiManager). That is stricter than the server gate
// _mi_is_admin() ((admin OR super admin) AND mi_access), so the portal never
// shows to someone the database would refuse. The server gate is the real
// fence (RLS on every mi_* table); this one only decides what is drawn.
// Fail-closed: 'loading' and 'error' never show the portal.
// ============================================================

// 'loading' | 'error' | 'allowed' | 'denied' — the one place the rule lives.
function useMailGateState() {
  const { data, isError } = usePortalPermissions();
  if (!data) return isError ? 'error' : 'loading';
  return isMiManager(data) ? 'allowed' : 'denied';
}

export function useCanSeeMailPortal() {
  return useMailGateState() === 'allowed';
}

// Route guard for tab === 'mail'. Anyone without the gate is sent back to Home
// and never loads the portal chunk; a failed permissions read says so.
export function MailGate({ children }) {
  const state = useMailGateState();
  const setEntryPhase = useUiStore((s) => s.setEntryPhase);
  useEffect(() => { if (state === 'denied') setEntryPhase('selection'); }, [state, setEntryPhase]);
  if (state === 'allowed') return children;
  if (state === 'error') {
    return <div role="alert" style={{ padding: 'var(--space-xl)', fontSize: 'var(--text-xs)', color: 'var(--text-label)' }}>Could not check access to Mail. Reload the page to try again.</div>;
  }
  return null;
}
